import TileType from '~/constants/TileType';
import type { ConditionalTile } from '~/contracts';

export type OwnProps = {
  filteredByMinDown: boolean;
  hasEligibleDownPaymentRange: boolean;
  hasPositiveEquityIfActiveTrade: boolean;
  showFinance: boolean;
};

export default function getDownPaymentTile({
  filteredByMinDown,
  hasEligibleDownPaymentRange,
  hasPositiveEquityIfActiveTrade,
  showFinance
}: OwnProps): ConditionalTile {
  const active =
    showFinance &&
    !filteredByMinDown &&
    hasEligibleDownPaymentRange &&
    hasPositiveEquityIfActiveTrade;

  return {
    active,
    index: 5,
    tileType: TileType.DownPayment
  };
}
